import { Node } from '@tiptap/core';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        tabSpan: {
            insertTabSpan: () => ReturnType;
        };
    }
}

export const TabSpan = Node.create({
    name: 'tabSpan',

    inline: true,
    group: 'inline',
    atom: true,
    selectable: false,

    parseHTML() {
        return [{ tag: 'span.tab' }];
    },

    renderHTML() {
        return ['span', { class: 'tab' }];
    },

    addCommands() {
        return {
            insertTabSpan:
                () =>
                    ({ commands }) =>
                        commands.insertContent({ type: this.name }),
        };
    },

    addKeyboardShortcuts() {
        return {
            Tab: () => this.editor.commands.insertTabSpan(),
        };
    },
});
